<nav class="navbar navbar-expand-md navbar-dark fixed-top bg-primary p-0">

  <a class="navbar-brand col-md-2 mr-0 text-white" routerLink="/home"
     style="box-shadow: none">
    <img src="../../../../../assets/images/logo_white.svg"
         class="capitan-logo-navbar d-inline-block align-top" alt="">
    CAPITAN

    <!-- The expand button is present on small and extra-small devices. -->
    <button class="navbar-toggler d-md-none float-right" type="button"
            data-toggle="collapse" data-target="#navbarCollapseArea"
            aria-controls="navbarCollapseArea" aria-expanded="false"
            aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
  </a>

  <span class="navbar-text text-light d-none d-md-block ml-4 email-text">
    <span *ngIf="accountService.myAccountInfoIsLoaded()">
      {{ accountService.getMyAccount().default_gym_name }}
      <span class="mx-1">-</span>
      <ng-container *ngIf="apiService.inPinMode">
        PIN Mode Enabled
      </ng-container>
      <ng-container *ngIf="!apiService.inPinMode">
        {{ accountService.getMyAccount().email }}
      </ng-container>
    </span>
    <span *ngIf="!accountService.myAccountInfoIsLoaded()">
      Loading...
    </span>
  </span>

  <ng-container  *ngIf="accountService.myAccountInfoIsLoaded()">
    <div class="d-md-none">
    <div class="collapse navbar-collapse" id="navbarCollapseArea">
      <ul class="navbar-nav px-3 ml-auto">
        <li class="nav-item"
            data-toggle="collapse" data-target="#navbarCollapseArea">
          <a class="nav-link" routerLink="/home" routerLinkActive="active">Home</a>
        </li>
        <li class="nav-item"
            data-toggle="collapse" data-target="#navbarCollapseArea">
          <a class="nav-link" routerLink="/sale" routerLinkActive="active">Sell</a>
        </li>
        <li class="nav-item"
            data-toggle="collapse" data-target="#navbarCollapseArea">
          <a class="nav-link" routerLink="/inbox" routerLinkActive="active">
            Inbox
            <span *ngIf="inboxService.getInboxCounts() && (inboxService.getInboxCounts().inbox_total > 0)">
              ({{ inboxService.getInboxCounts().inbox_total }})
            </span>
          </a>
        </li>
        <li class="nav-item"
            data-toggle="collapse" data-target="#navbarCollapseArea">
          <a class="nav-link" routerLink="/check-in" routerLinkActive="active">Check-In</a>
        </li>
        <li class="nav-item"
            data-toggle="collapse" data-target="#navbarCollapseArea">
          <a class="nav-link" routerLink="/customers" routerLinkActive="active">Customers</a>
        </li>
        <li class="nav-item"
            data-toggle="collapse" data-target="#navbarCollapseArea">
          <a class="nav-link" routerLink="/recently-active-customers" routerLinkActive="active">Recently Active</a>
        </li>
        <li class="nav-item"
            data-toggle="collapse" data-target="#navbarCollapseArea">
          <a class="nav-link" routerLink="/associations" routerLinkActive="active">Associations</a>
        </li>
        <li class="nav-item"
            data-toggle="collapse" data-target="#navbarCollapseArea">
          <a class="nav-link" routerLink="/events" routerLinkActive="active">Events</a>
        </li>
        <li *ngIf="accountService.getMyAccount().is_capitan_staff"
            class="nav-item"
            data-toggle="collapse" data-target="#navbarCollapseArea">
          <a class="nav-link" routerLink="/retail" routerLinkActive="active">Retail</a>
        </li>
        <li class="nav-item"
            data-toggle="collapse" data-target="#navbarCollapseArea">
          <a class="nav-link" routerLink="/payments" routerLinkActive="active">Payments</a>
        </li>
        <li *ngIf="accountService.getMyAccount().can_access_reports"
            class="nav-item"
            data-toggle="collapse" data-target="#navbarCollapseArea">
          <a class="nav-link" routerLink="/reporting" routerLinkActive="active">Reporting</a>
        </li>
        <li class="nav-item"
            data-toggle="collapse" data-target="#navbarCollapseArea"
            *ngIf="orgConfig.getOrganizationConfig() && orgConfig.getOrganizationConfig().time_tracking_enabled">
          <a class="nav-link" href="#" (click)="openClockInOutModal(); $event.preventDefault();">
            Clock In/Out
          </a>
        </li>
        <li class="nav-item"
            data-toggle="collapse" data-target="#navbarCollapseArea"
            [ngbTooltip]="apiService.inPinMode ? 'Account settings cannot be changed in PIN mode.' : null">
          <a class="nav-link"
             [class.disabled]="apiService.inPinMode"
             [routerLink]="apiService.inPinMode ? null : '/account-settings'"
             routerLinkActive="active">
            Account Settings
          </a>
        </li>
        <li class="nav-item ml-lg-2 ml-md-1"
            data-toggle="collapse" data-target="#navbarCollapseArea">
          <a class="nav-link" href="https://capitan.helpscoutdocs.com/" target="_blank">
            Knowledge Base
          </a>
        </li>
        <li class="nav-item"
            data-toggle="collapse" data-target="#navbarCollapseArea">
          <a class="nav-link" routerLink="/admin" routerLinkActive="active">
            Admin
          </a>
        </li>
        <hr class="nav-collapse-separator d-md-none">
        <li class="nav-item text-nowrap ml-lg-2 ml-md-1">
          <a (click)="handleLogoutClick($event)" class="nav-link" href="#">Log out</a>
        </li>
      </ul>
    </div>

    </div>

    <ul class="navbar-nav px-3 ml-auto d-none d-md-flex">
      <li class="nav-item"
          [ngbTooltip]="apiService.inPinMode ? 'Account settings cannot be changed in PIN mode.' : null">
        <a class="nav-link"
           [class.disabled]="apiService.inPinMode"
           [routerLink]="apiService.inPinMode ? null : '/account-settings'"
           routerLinkActive="active">
          Account Settings
        </a>
      </li>
      <li class="nav-item ml-lg-2 ml-md-1">
        <a class="nav-link" href="https://capitan.helpscoutdocs.com/" target="_blank">
          Knowledge Base
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/admin" routerLinkActive="active">
          Admin
        </a>
      </li>
      <li class="nav-item text-nowrap ml-lg-2 ml-md-1">
        <a (click)="handleLogoutClick($event)" class="nav-link" href="#">Log out</a>
      </li>
    </ul>
  </ng-container>

</nav>
